import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import "./Astrologer.css";

const AstrologerSection = () => {
  const [astrologers, setAstrologers] = useState([]);
  const [visibleCount, setVisibleCount] = useState(6);
  const [filters, setFilters] = useState({ language: "", expertise: "" });

  const navigate = useNavigate();

  useEffect(() => {
    fetch("https://dashboard.jyotirvani.com/api/fetchastrologer")
      .then((res) => res.json())
      .then((res) => {
        if (res.status && Array.isArray(res.data)) {
          const basePath = "https://dashboard.jyotirvani.com/" + res.path;

          const formattedData = res.data.map((item) => ({
            id: item.id,
            name: item.name,
            experience: item.experience + " Years",
            languages: item.speak ? item.speak.split(",").map((l) => l.trim()) : [],
            expertise: item.Expertise
              ? item.Expertise.split(",").map((e) => e.trim())
              : [],
            availableVia: item.Available
              ? item.Available.split(",").map((a) => a.trim())
              : [],
            profileImage: basePath + item.profileimage,
            tag: "Top Rated",
            rating: "4.8",
            status: item.status === 1 ? "Online" : "Offline",
          }));

          setAstrologers(formattedData);
        } else {
          console.error("Unexpected API format", res);
        }
      })
      .catch((err) => console.error("Failed to fetch astrologers:", err));
  }, []);

  const allLanguages = [
    ...new Set(astrologers.flatMap((a) => a.languages || [])),
  ];

  const allExpertise = [
    ...new Set(astrologers.flatMap((a) => a.expertise || [])),
  ];

  const handleViewProfile = (astro) => {
    navigate(`/profile/${astro.id}`);
  };

  const handleChatNow = (astro) => {
    navigate(`/chat/${astro.id}`);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const filteredAstrologers = astrologers.filter((a) => {
    const matchesLanguage = filters.language
      ? a.languages.includes(filters.language)
      : true;

    const matchesExpertise = filters.expertise
      ? a.expertise.includes(filters.expertise)
      : true;

    return matchesLanguage && matchesExpertise;
  });

  const visibleAstrologers = filteredAstrologers.slice(0, visibleCount);

  return (
    <div className="ra-pandit-main">
      <div className="container">
        <h2>Consult with Best Astrologers</h2>

        <div className="row mb-4">
          <div className="col-md-6">
            <div className="ra-pandit-filter1">
              <label>Filter by Language</label>
              <select
                name="language"
                className="form-select"
                onChange={handleFilterChange}
                value={filters.language}
              >
                <option value="">All Languages</option>
                {allLanguages.map((lang, i) => (
                  <option key={i} value={lang}>
                    {lang}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="col-md-6">
            <div className="ra-pandit-filter2">
              <label>Filter by Expertise</label>
              <select
                name="expertise"
                className="form-select"
                onChange={handleFilterChange}
                value={filters.expertise}
              >
                <option value="">All Expertise</option>
                {allExpertise.map((exp, i) => (
                  <option key={i} value={exp}>
                    {exp}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="row">
          {visibleAstrologers.map((astro) => (
            <div className="col-md-4 mb-4" key={astro.id}>
              <div className="card h-100">
                <div className="ra-main-picanddeatial">
                  <div className="ra-card-img">
                    <img
                      src={astro.profileImage}
                      className="card-img-top"
                      alt={astro.name}
                    />
                  </div>

                  <div className="ra-card-deital">
                    <h5 className="card-title">{astro.name}</h5>
                    <p>{astro.experience} of experience</p>
                    <p>
                      Status:{" "}
                      <span
                        className={
                          astro.status === "Online"
                            ? "text-success"
                            : "text-danger"
                        }
                      >
                        {astro.status}
                      </span>
                    </p>
                    <p>⭐ {astro.rating}</p>
                  </div>
                </div>

                <span className="ra-badge">{astro.tag}</span>

                <div className="ra-pandit-card-body">
                  <p>
                    <strong>Speak:</strong> {astro.languages.join(", ")}
                  </p>
                  <p>
                    <strong>Expertise:</strong> {astro.expertise.join(", ")}
                  </p>
                  <p>
                    <strong>Available via:</strong> {astro.availableVia.join(", ")}
                  </p>
                </div>

                <div className="card-footer d-flex justify-content-between">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => handleViewProfile(astro)}
                  >
                    View Profile
                  </button>

                  <button
                    type="button"
                    className="btn btn-warning"
                      onClick={() => handleViewProfile(astro)}
                  >
                    Chat Now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {visibleCount < filteredAstrologers.length && (
          <div className="text-center mt-4">
            <button
              className="btn btn-primary"
              onClick={() => setVisibleCount((prev) => prev + 3)}
            >
              Load More
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AstrologerSection;